export default "__VITE_ASSET__CghXYnDD__"